module.exports = "/static/media/status_icon.94367a97.svg";